











import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import QRCode from '@/components/QRCode.vue';
import clientWidth, {getWindowConfig} from '@/lib/getClient.ts';

@Component({
  components: {QRCode}
})
export default class App extends Vue {
  show = true;

  hideQRCode() {
    this.show = false;
  }

  mounted() {
    if (clientWidth() === 'mobile') {
      this.$nextTick(() => {
        const pageInfo = getWindowConfig();
        (this.$refs.app as HTMLElement).style.height
          = (pageInfo.windowHeight - 46) + 'px';
      });
    }
  }

}
